import { render, staticRenderFns } from "./VideoProjectItemVideo.vue?vue&type=template&id=21938356&scoped=true&"
import script from "./VideoProjectItemVideo.vue?vue&type=script&lang=js&"
export * from "./VideoProjectItemVideo.vue?vue&type=script&lang=js&"
import style0 from "./VideoProjectItemVideo.vue?vue&type=style&index=0&id=21938356&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../voicecasting.sk/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21938356",
  null
  
)

export default component.exports